import { Navigate, Route, Routes } from "react-router-dom";
import {
  CurrentAnswerProvider,
  ExplanationSidebarProvider,
} from "@coffee/contexts";
import { ChatStateProvider } from "@coffee/ui/components/chat";
import { Chat, Recents } from "@coffee/ui/features/chat";
import { AppLayout } from "@coffee/ui/layouts";
import { RequireAuth } from "./RequireAuth";

export const AppRouter = () => (
  <RequireAuth>
    <ChatStateProvider>
      <ExplanationSidebarProvider>
        <CurrentAnswerProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/chat" replace />} />
            <Route element={<AppLayout />}>
              <Route>
                <Route path="/chat" element={<Chat />} />
                <Route path="/recents" element={<Recents />} />
              </Route>
            </Route>
          </Routes>
        </CurrentAnswerProvider>
      </ExplanationSidebarProvider>
    </ChatStateProvider>
  </RequireAuth>
);
